import { render, staticRenderFns } from "./marquee-kyroro.vue?vue&type=template&id=1aa7e474&scoped=true&"
import script from "./marquee-kyroro.vue?vue&type=script&lang=js&"
export * from "./marquee-kyroro.vue?vue&type=script&lang=js&"
import style0 from "./marquee-kyroro.vue?vue&type=style&index=0&id=1aa7e474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7e474",
  null
  
)

export default component.exports